import { render, staticRenderFns } from "./ComposerAttachmentPane.vue?vue&type=template&id=7944f5a4&scoped=true"
import script from "./ComposerAttachmentPane.vue?vue&type=script&lang=js"
export * from "./ComposerAttachmentPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944f5a4",
  null
  
)

export default component.exports